import React, {useContext} from 'react';
import {useFormState} from 'react-hook-form';
import {IListColumnProps} from '@src/@interfaces/components/List/IListColumnProps';
import {IOrderModel} from '@src/@interfaces/models/Order/IOrderModel';
import {FormFieldDesignContext} from '@src/contexts/FormFieldDesignContext';
import classnames from '@src/helpers/classnames';
import {IFormFieldItemPropsContext} from '@src/@interfaces/contexts/IFormFieldItemPropsContext';
import {FormFieldItemPropsContext} from '@src/contexts/FormFieldItemPropsContext';
import FormErrorMessage from '@src/components/Form/FormErrorMessage';
import FormattedPrice from '@src/components/FormattedPrice/FormattedPrice';
import useFormValue from '@src/hooks/useFormValue';

export function AmountField({rowIndex: index}: IListColumnProps) {
    const {
        control,
        fieldName,
        forceReadonly,
        forceDisabled,
    } = useContext<IFormFieldItemPropsContext<IOrderModel> | null>(FormFieldItemPropsContext) ?? {};
    const [design] = useContext(FormFieldDesignContext);
    const {errors} = useFormState<IOrderModel>({control});
    const {currentValue} = useFormValue(fieldName ?? '');

    const isExistedRecord = Boolean(currentValue?.[index].id);
    const initialValue = currentValue?.[index].amount ?? 0;

    if (!control || isExistedRecord) {
        return <FormattedPrice amount={initialValue}/>;
    }

    return <>
        <input
                type="number"
                className={classnames('form-control form-control-sm', {
                    'is-invalid': Boolean(errors.payments?.[index]?.amount)
                })}
                step={1}
                min={1}
                {...control.register(`${fieldName}.${index}.amount`)}
                readOnly={design.fieldsAreReadOnly || forceReadonly}
                disabled={design.fieldsAreDisabled || forceDisabled}
        />

        <FormErrorMessage fieldName={`${fieldName}.${index}.amount`}/>
    </>;
}
